/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1177
 */

var r = require(/* 728 */"./728/index")(require(/* 502 */"../../../../../../2588/1461/2585/502/index"), "Map")
module.exports = r
